import * as ContextMenu from "@radix-ui/react-context-menu";
import type { MouseEvent, ReactNode } from "react";

import type { FileManagerItem } from "@/components/core/FileManager";
import { useFileManagerUI } from "@/components/core/FileManager/FileManagerContext/FileManagerUIContext";

import { FileManagerItemDefaultMenuItems } from "./FileManagerItemMenuItems";

import styles from "./FileManagerContextMenu.module.scss";

export function FileManagerMenuSeparator() {
  return <ContextMenu.Separator className={styles.separator} />;
}

interface FileManagerItemContextMenuProps {
  item: FileManagerItem;
  children: ReactNode;
  menuContent?: ReactNode;
}

export function FileManagerItemContextMenu({
  item,
  children,
  menuContent,
}: FileManagerItemContextMenuProps) {
  const { isSelected, selectItem, deselectAll } = useFileManagerUI();

  const handleContextMenu = (e: MouseEvent) => {
    e.stopPropagation();
    if (!isSelected(item.id)) {
      deselectAll();
      selectItem(item);
    }
  };

  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger asChild>
        <div onContextMenu={handleContextMenu} style={{ display: "contents" }}>
          {children}
        </div>
      </ContextMenu.Trigger>
      <ContextMenu.Portal>
        <ContextMenu.Content className={styles.content}>
          {menuContent ?? <FileManagerItemDefaultMenuItems item={item} />}
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
}
